import React from 'react';
import { Menu } from 'lucide-react';

const Header = ({ page, toggleSidebar }) => {
    const pageTitles = {
        dashboard: 'Inicio / Dashboard',
        registrar: 'Registrar Nueva Multa',
        buscar: 'Buscar Multas',
        pagar: 'Registrar Pago de Multas',
        reportes: 'Generación de Reportes',
        infracciones: 'Gestionar Tipos de Infracción',
        usuarios: 'Gestión de Usuarios',
    };

    return (
        <header className="bg-white shadow-md p-4 flex items-center z-10">
            {/* Botón de Menú para móviles */}
            <button
                onClick={toggleSidebar}
                className="text-gray-600 sm:hidden mr-4"
                aria-label="Abrir menú"
            >
                <Menu size={28} />
            </button>
            <h1 className="text-xl md:text-2xl font-bold text-gray-800">
                {pageTitles[page] || 'Sistema de Multas'}
            </h1>
        </header>
    );
};

export default Header;
